import { Stack } from '@jotta/ui/Stack'
import { RadixDialog } from '@jotta/ui/RadixDialog'
import type { RadixModalProps } from '@jotta/ui/RadixModal'
import { RadixModal } from '@jotta/ui/RadixModal'
import { t } from '@lingui/macro'

export interface FileReadErrorDialogProps extends RadixModalProps {
  paths: string[]
}

export const FileReadErrorDialog = ({
  onClose,
  paths,
  ...props
}: FileReadErrorDialogProps) => {
  return (
    <RadixModal open={paths.length > 0} onClose={onClose} {...props}>
      <RadixDialog
        data-testid="PermanentlyDeleteDialog"
        onClose={onClose}
        title={t`An error occured!`}
        buttons={[{ action: 'close', label: t`Close`, type: 'outline' }]}
      >
        <p>{t`Could not read all the files`}:</p>
        <Stack>
          {paths.map(path => (
            <div key={path}>{path}</div>
          ))}
        </Stack>
      </RadixDialog>
    </RadixModal>
  )
}
